import { render, staticRenderFns } from "./RealState.vue?vue&type=template&id=873a2142&scoped=true&"
import script from "./RealState.vue?vue&type=script&lang=js&"
export * from "./RealState.vue?vue&type=script&lang=js&"
import style0 from "./RealState.vue?vue&type=style&index=0&id=873a2142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873a2142",
  null
  
)

export default component.exports